// FINALLY, check to see if this page has been specified to print on
// load
if (
  ht.parseUrlQuery(document.URL).printOnLoad &&
  ht.parseUrlQuery(document.URL).printOnLoad == 1
) {
  ht.printPage();
}
